import { render } from "./TabelTask.vue?vue&type=template&id=9affe042"
import script from "./TabelTask.vue?vue&type=script&lang=js"
export * from "./TabelTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__